// api/urls.ts

//prod
//  const BASE_URL = "https://admin.mytriva.com/";
//stage
  //  const BASE_URL = "https://stage.mytriva.com/";

  //test
    const BASE_URL = "https://api.openuidev.com/";

export const IS_STAGING = BASE_URL.includes("stage.");

export const API_URLS = {
  GET_USER_ID: `${BASE_URL}get_token/`,
  ADD_USER_PAYMENT: `${BASE_URL}add_user_payment/`,
  Get_STANDARD_PLANS: `${BASE_URL}get_standard_plans/`,
  GET_COMPLEMENTARY_PLANS: `${BASE_URL}get_standard_plans/?visibility=complimentary`,
  UPDATE_PAYMENT_STATUS: `${BASE_URL}update_payment_status/`, 

  USER_LOGIN: `${BASE_URL}user_login/`,
  OTP_VERIFY: `${BASE_URL}verify_otp/`,
  UPDATE_USER_NAME: `${BASE_URL}update_user/`,

  GET_USER_INFO: `${BASE_URL}get_user_info/`, 
  UPDATE_USER_INFO: `${BASE_URL}update_user_info/`,
  

  // Function to get user personal plan with user_id
  GET_USER_PERSONAL_PLAN: (userId: number | string): string => 
    `${BASE_URL}get_user/${userId}/`,
    
  UPDATE_PERSONAL_PLAN_REQUEST : `${BASE_URL}add_personal_plan_request/`,

  UPLOAD_INVOICE_PDF: `${BASE_URL}upload_invoice_pdf/`,
  UPLOAD_INVOICE_And_SEND_EMAIL_DESKTOP: `${BASE_URL}upload_invoice_and_email/`,

  // Function to get invoice download URL with user_payment_id
  GET_INVOICE: (userPaymentId: number | string): string => 
    `${BASE_URL}download_invoice/${userPaymentId}/`,

  VERIFY_DEEPLINK: `${BASE_URL}magic_link_validate/`,
};

// Razorpay Configuration
export const RAZORPAY_CONFIG = {
  KEY_ID: (() => {
    const keyId = process.env.REACT_APP_RAZORPAY_KEY_ID;
    if (!keyId) {
      console.error('❌ REACT_APP_RAZORPAY_KEY_ID is not defined in environment variables');
      throw new Error('Razorpay Key ID is required. Please set REACT_APP_RAZORPAY_KEY_ID in your .env file');
    }
    console.log('✅ Razorpay Key ID loaded from environment in API config');
    return keyId;
  })(),
  CURRENCY: 'INR',
  COMPANY_NAME: 'Triva',
  THEME_COLOR: '#0DB5B5',
  // Test mode - set to false in production
  TEST_MODE: process.env.NODE_ENV !== 'production'
};

export default API_URLS;